import React, { useEffect, useState } from 'react';
import axios from '../../../utils/axios';
import { Container, Grid, Typography, Paper, Button, useMediaQuery, useTheme } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import Footer from '../../Partial/footer/footer';
import Navbar from '../../Partial/navbar/Navbar';

const DealDetail = () => {
  const { id } = useParams(); // Get the deal ID from the URL params
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  //const [userRole, setUserRole] = useState(localStorage.getItem('userRole'));
  const [userRole] = useState(localStorage.getItem('userRole'));
  const navigate = useNavigate();
  
  // Responsive hook
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Check if screen width is 'small' or 'xs' (mobile)

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        const response = await axios.get(`/deals/${id}`);
        setDeal(response.data);
      } catch (error) {
        setError('Error fetching deal details');
      } finally {
        setLoading(false);
      }
    };

    fetchDeal();
  }, [id]);

  const handleGoBack = () => {
    navigate('/discover'); // Use navigate() to go back to the deals list page or home
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (error) {
    return <Typography>{error}</Typography>;
  }

  // Check if 'deal' is available before rendering the rest
  if (!deal) {
    return <Typography>No deal found</Typography>;
  }

  // Function to convert newlines into <br /> tags
  const formatContent = (content) => {
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <div style={{ backgroundColor: '#c6b79b' }}>
      <Navbar />
      <Container
        style={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} md={9}>
            <Paper elevation={3} style={{ padding: '20px', backgroundColor: 'beige'  }}>
              <Typography variant="h4" gutterBottom>
                {deal.title}
              </Typography>
              <img
                src={deal.imageLink}
                alt={deal.title}
                style={{
                  width: isMobile ? '100%' : 'auto',  // Full width on mobile, auto on larger screens
                  height: isMobile ? 'auto' : '310px', // Auto height on mobile, fixed height on larger screens
                  objectFit: 'cover',  // Maintain aspect ratio and cover container
                }}
              />
              <Typography variant="body1" paragraph>
                {deal.description}
              </Typography>
              <Typography variant="body2" paragraph>
                {/* Render the content with new lines */}
                {formatContent(deal.content)}
              </Typography>
              <Button variant="contained" color="secondary" onClick={handleGoBack}>
                Go Back
              </Button>
              {userRole === 'admin' && (
              <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={() => navigate(`/discover/deal/${id}/edit`)}>
                Edit Post
              </Button>
              )}
              {/* {userRole === 'admin' && (
      <button onClick={() => navigate(`/discover/deal/${id}/edit`)}>edit Deals</button>
    )} */}
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
};

export default DealDetail;
